import * as React from "react";
import CustomCSS from "./CustomCSS/container";
import Responsive from "./Responsive/container";
import StyleSheet from "./StyleSheet/component";
import Variables from "./Variables";

const Assets = () => (
  <>
    <Variables />
    <StyleSheet />
    <Responsive />
    <CustomCSS />
  </>
);
export default Assets;
